export default {
    speed: 500,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    simulateTouch: false,
    allowTouchMove: true,
    spaceBetween: 300,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/card-stack/card-slider/slider-config.js